module.exports = __webpack_public_path__ + "static/media/foto_03_head.5081675f.jpg";